import { utf8_to_b64 } from "../../utilities/utils";
import { VehiculoModel, VehiculoTipoBusModel } from "../vehiculo/vehiculo.model";

export class UserModel {
    codempleado?: number;
    login?: string;
    password?: string;
    nomusu?: string;
    // token: string;
    basicauth?: string;
    numempre?: number;
    dni?: string;
    activeVehicle: VehiculoModel[];
    loginTaxis?: TaxisAuthModel;
    tokenMensajeria?: string;
    tokenTad?: string;
    tokenTrafico?: string;
    tokenTaller?: string;
    _id?: string;
}

export class TaxisAuthModel {
    vehiculo: VehiculoTipoBusModel;
    //puede ser igual o diferente la matrícula a la del vehículo.matricula,
    //ya que hay casos que se comparte el login entre vehículos y no se guardan en planner las matrículas, sino usuarios genéricos
    matricula: string;
}

export class DnsModel {
    id: number;
    iddevice: string;
    login: string;
    password: string;
    empresa: string;
    fecha: Date;
    matricula: string;
    app?: number;

    constructor(
        iddevice: string,
        login: string,
        password: string,
        empresa: string,
        app?: number
    ) {
        this.iddevice = iddevice;
        this.login = utf8_to_b64(login);
        this.password = utf8_to_b64(password);
        this.empresa = utf8_to_b64(empresa);
        this.app = app;
    }
}
